import { getBrowserOS } from '@web-chat-core/ui-kit';
import { isIOS } from 'react-device-detect';

export const enum APP_NAME {
    F = 'F',
    K = 'K',
    T = 'T',
    S = 'S',
}

interface AppInfo {
    currentAppName: APP_NAME;
    desktopSchema: string;
    isF: boolean;
    isK: boolean;
    isT: boolean;
    isS: boolean;
    desktopPlatformDownloadLink: string;
    downloadLinkWindows: string;
    downloadLinkMac: string;
    downloadLinkLinux: string;
    mobilePlatformDownloadLink: string;
}

export const getAppInfo = (): AppInfo => {
    const isF = process.env.REACT_APP_IS_F === 'true';
    const isK = process.env.REACT_APP_IS_K === 'true';
    const isT = process.env.REACT_APP_IS_T === 'true';
    const isS = process.env.REACT_APP_IS_S === 'true';
    const desktopSchema = process.env.REACT_APP_DESKTOP_PROTOCOL_SCHEME || '';

    const downloadLinkWindows = process.env.REACT_APP_DOWNLOAD_WINDOWS || '';
    const downloadLinkMac = process.env.REACT_APP_DOWNLOAD_MAC || '';
    const downloadLinkLinux = process.env.REACT_APP_DOWNLOAD_LINUX || '';
    const mobilePlatformDownloadLink = isIOS
        ? process.env.REACT_APP_IOS_APP_STORE_URL
        : process.env.REACT_APP_ANDROID_PLAY_STORE_DEEP_URL;

    let currentAppName = APP_NAME.F;
    if (isK) currentAppName = APP_NAME.K;
    if (isT) currentAppName = APP_NAME.T;
    if (isS) currentAppName = APP_NAME.S;

    const platform = getBrowserOS();
    let desktopPlatformDownloadLink = '';
    switch (platform) {
        case 'ios': {
            desktopPlatformDownloadLink = downloadLinkMac;
            break;
        }
        case 'windows': {
            desktopPlatformDownloadLink = downloadLinkWindows;
            break;
        }
        case 'linux': {
            desktopPlatformDownloadLink = downloadLinkLinux;
            break;
        }
        default: {
            break;
        }
    }

    return {
        currentAppName,
        desktopSchema,
        isF,
        isK,
        isT,
        isS,
        desktopPlatformDownloadLink,
        downloadLinkWindows,
        downloadLinkMac,
        downloadLinkLinux,
        mobilePlatformDownloadLink: mobilePlatformDownloadLink || '',
    };
};
